import { FormGroup } from 'reactstrap';

import DynamicFormField from './DynamicFormField';

const GeneratedFormSection = ({
    section,
    values,
    t,
    lng,
    countriesList,
    onChange,
}) => {
    return (
        <FormGroup>
            {section.titleKey && (
                <p className="sub-header medium">
                    {t(section.titleKey)}
                </p>
            )}
            <div className="row">
                {section.fields.map((field) => (
                    <DynamicFormField
                        key={field.key}
                        field={field}
                        values={values}
                        t={t}
                        lng={lng}
                        countriesList={countriesList}
                        onChange={onChange}
                    />
                ))}
            </div>
        </FormGroup>
    );
};

export default GeneratedFormSection;
